import Loadable from 'react-loadable';

const LazyCreateTeamDialog = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_create-team-dialog" */ './main'
		),
	loading: () => null,
});
LazyCreateTeamDialog.displayName = 'lazy(CreateTeamDialog)';

export default LazyCreateTeamDialog;
